const brandingGlobal = {
  config: {
    general: {
      logo: {
        media: {
          url: "https://tc-media.job-shop.com/ms3-editor/default-logo/default-logo.svg?format=webp",
          mediaType: "image",
        },
      },
      favicon: {
        media: {
          url: "",
          mediaType: "",
        },
      },
    },
  },
};

export default brandingGlobal;
